module.exports = __webpack_public_path__ + "static/media/night.83cd5882.svg";